import { differenceInSeconds } from 'date-fns';
import React from 'react';

const getSecondsRemaining = (date) => {
  const diff = differenceInSeconds(date, new Date());
  return Math.max(0, diff || 0);
};

// Countdown uses a date instead of seconds because when you leave the tab, timer is slowing down in browser
const useCountdown = ({ date }) => {
  const intervalRef = React.useRef(undefined);
  const [countdown, setCountdown] = React.useState();

  const decrement = React.useCallback(() => {
    const newCountdown = Math.max(0, countdown - 1);
    if (newCountdown === 0) {
      clearInterval(intervalRef.current);
    }
    setCountdown(newCountdown);
  }, [countdown]);

  React.useEffect(() => {
    setCountdown(getSecondsRemaining(date));
  }, [date]);

  React.useEffect(() => {
    intervalRef.current = setInterval(decrement, 1000);
    return () => clearInterval(intervalRef.current);
  }, [decrement]);

  return { countdown };
};

export default useCountdown;
